export default [
  'Spirit Box',
  'Fingerprints',
  'Ghost Writing',
  'Freezing Temperatures',
  'EMF Level 5',
  'Ghost Orb',
  'DOTS Projector'
]
